import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
  Button,
} from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useTranslation } from '@/kit/useTranslation';

export default function BlockedAmountInfoDialog({ open, onClose }) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Lock sx={{ color: '#ff9800' }} />
          <Typography variant="h6" fontWeight={700}>
            {t('payment.wallet.blockedAmount')}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" paragraph>
          {t('payment.wallet.blockedAmountInfo1')}
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          {t('payment.wallet.blockedAmountInfo2')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('payment.wallet.blockedAmountInfo3')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          {t('payment.gotIt')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
